<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <ik-data-table
    ref="table"
    :custom-on-row-click="()=>{}"
    :model="model"
    :required-date-value="dates"
    :use-date-filter="true"
    :use-default-action="false"
    :use-edit-action="false"
    entity-name="InventoryRecords"
  >
    <template #right>
      <v-btn
        color="amber lighten-4 black--text"
        elevation="0"
        @click="clearLog"
      >
        {{ $t('cleanLog') }}
      </v-btn>
    </template>
    <template #footer>
      <!-- Display information about storage records here if needed -->
    </template>
  </ik-data-table>
</template>

<script>
import Records from '@/model/dataLayer/api/storage/Records'
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import { today } from '@/model/utils/DateRepository'
import { clearAllLogs } from '@/model/dataLayer/api/storage/storage'
import IKUtils from 'innerken-js-utils'

export default {
  name: 'StorageRecords',
  components: {
    IkDataTable
  },
  data: function () {
    return {
      model: Records,
      dates: [today, today]
    }
  },
  methods: {
    clearLog () {
      clearAllLogs()
      IKUtils.toast('成功')
      this.$refs.table.reload()
    }
  },
  mounted () {
    this.dates = [today, today]
  }
}
</script>

<style scoped>

</style>
